var map = {
	"./0.bmp": 18,
	"./1.bmp": 19,
	"./2.bmp": 20,
	"./3.bmp": 21,
	"./4.bmp": 22,
	"./5.bmp": 23,
	"./6.bmp": 24
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;



//////////////////
// WEBPACK FOOTER
// ./assets ^\.\/.*\.bmp$
// module id = 17
// module chunks = 0